import React, { useState } from 'react';
import { Bars3Icon, BellIcon, UserCircleIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const Header = ({ user, setSidebarOpen, isMobile }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const getRoleDisplayName = (role) => {
    switch(role) {
      case 'superadmin': return 'Super Administrator';
      case 'admin': return 'Administrator';
      case 'hr': return 'HR Manager';
      case 'manager': return 'Department Manager';
      case 'employee': return 'Employee';
      default: return 'Staff';
    }
  };

  const getRoleBadgeColor = () => {
    switch(user?.role) {
      case 'superadmin': return 'bg-red-100 text-red-700';
      case 'admin': return 'bg-purple-100 text-purple-700';
      case 'hr': return 'bg-blue-100 text-blue-700';
      case 'manager': return 'bg-green-100 text-green-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const notifications = [
    { id: 1, text: 'John Doe requested leave', time: '5 min ago', read: false },
    { id: 2, text: 'New employee joined', time: '1 hour ago', read: false },
    { id: 3, text: 'Payroll processed', time: '2 hours ago', read: true },
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-10">
      <div className="flex items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center gap-3 md:gap-4">
          {isMobile && (
            <button onClick={() => setSidebarOpen(true)} className="p-2 rounded-lg hover:bg-gray-100">
              <Bars3Icon className="w-6 h-6 text-gray-600" />
            </button>
          )}
          
          <div className="hidden md:flex items-center bg-gray-100 rounded-lg px-3 py-2">
            <MagnifyingGlassIcon className="w-5 h-5 text-gray-400" />
            <input type="text" placeholder="Search..." className="bg-transparent border-none outline-none ml-2 w-64 text-sm" />
          </div>
        </div>
        
        <div className="flex items-center gap-3 md:gap-4">
          <div className="relative">
            <button onClick={() => setShowNotifications(!showNotifications)} className="p-2 rounded-lg hover:bg-gray-100 relative">
              <BellIcon className="w-5 h-5 md:w-6 md:h-6 text-gray-600" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border z-50">
                <div className="p-3 border-b"><h3 className="font-semibold">Notifications</h3></div>
                <div className="max-h-96 overflow-y-auto">
                  {notifications.map(notif => (
                    <div key={notif.id} className={`p-3 border-b hover:bg-gray-50 ${!notif.read ? 'bg-blue-50' : ''}`}>
                      <p className="text-sm text-gray-800">{notif.text}</p>
                      <p className="text-xs text-gray-400 mt-1">{notif.time}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          
          <div className="relative">
            <button onClick={() => setShowProfile(!showProfile)} className="flex items-center gap-2 p-1 rounded-lg hover:bg-gray-100">
              <UserCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-gray-600" />
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-gray-800">{user?.name || 'User'}</p>
                <p className="text-xs text-gray-500 capitalize">{getRoleDisplayName(user?.role)}</p>
              </div>
            </button>
            
            {showProfile && (
              <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border z-50">
                <div className="p-4 border-b bg-gradient-to-r from-indigo-50 to-purple-50">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-indigo-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                      {user?.name?.charAt(0) || 'U'}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">{user?.name || 'User'}</p>
                      <p className="text-sm text-gray-500">{user?.contact || 'user@example.com'}</p>
                      <span className={`inline-block mt-1 text-xs px-2 py-0.5 rounded-full ${getRoleBadgeColor()}`}>
                        {getRoleDisplayName(user?.role)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="py-2">
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">My Profile</button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">Account Settings</button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">Change Password</button>
                  <hr className="my-1" />
                  <button className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50">Logout</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;